var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [
          _vm._v("Cartera del cliente " + _vm._s(_vm.cliente.nombre_comercial))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-info",
              attrs: { type: "button" },
              on: { click: _vm.consultar }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _c("span", [_vm._v("Consultar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "btn-danger", on: { click: _vm.exportarPDF } },
            [
              _c("i", { staticClass: "fa fa-file-pdf-o" }),
              _c("span", [_vm._v("Exportar PDF")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: { name: "tipo_fecha", id: "tipo_fecha" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "tipo_fecha",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.changeTipoFecha
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { value: "F" } }, [
                      _vm._v("A la fecha")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "H" } }, [_vm._v("Hoy")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "A" } }, [_vm._v("Ayer")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "P" } }, [
                      _vm._v("Personalizado")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "tipo_fecha" } }, [
                  _vm._v("Tipo de fecha")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.tipo_fecha === "P",
                    expression: "form.tipo_fecha === 'P'"
                  }
                ],
                staticClass: "form-field"
              },
              [
                _c(
                  "div",
                  { staticClass: "datepicker-field datepicker-field--stretch" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "desde",
                        locale: "es",
                        "no-label": "",
                        "only-date": "",
                        "auto-close": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.desde,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "desde", $$v)
                        },
                        expression: "form.desde"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Desde")])
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.tipo_fecha === "P",
                    expression: "form.tipo_fecha === 'P'"
                  }
                ],
                staticClass: "form-field"
              },
              [
                _c(
                  "div",
                  { staticClass: "datepicker-field datepicker-field--stretch" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "hasta",
                        locale: "es",
                        "no-label": "",
                        "only-date": "",
                        "auto-close": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.hasta,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "hasta", $$v)
                        },
                        expression: "form.hasta"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Hasta")])
                  ],
                  1
                )
              ]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card mt-2" }, [
      _c(
        "div",
        { staticClass: "card__content" },
        [
          _c(
            "vs-table",
            {
              attrs: {
                search: "",
                "max-items": "20",
                pagination: "",
                data: _vm.mostrarSinSaldos(_vm.registros)
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var data = ref.data
                    return _vm._l(data, function(tr, indextr) {
                      return _c(
                        "vs-tr",
                        { key: indextr, attrs: { data: tr } },
                        [
                          _c("vs-td", [
                            _vm._v(
                              _vm._s(data[indextr].cod_tipo_doc) +
                                "-" +
                                _vm._s(data[indextr].num_doc)
                            )
                          ]),
                          _vm._v(" "),
                          _c("vs-td", [
                            _vm._v(_vm._s(data[indextr].fecha_doc))
                          ]),
                          _vm._v(" "),
                          _c("vs-td", [
                            _vm._v(_vm._s(data[indextr].fecha_vencto))
                          ]),
                          _vm._v(" "),
                          _c("vs-td", [
                            _vm._v(_vm._s(_vm.calcularMora(data[indextr])))
                          ]),
                          _vm._v(" "),
                          _c("vs-td", [_vm._v(_vm._s(data[indextr].concepto))]),
                          _vm._v(" "),
                          _c("vs-td", [
                            _vm._v(_vm._s(_vm.moneyFormat(data[indextr].total)))
                          ]),
                          _vm._v(" "),
                          _c("vs-td", [
                            _vm._v(
                              _vm._s(_vm.moneyFormat(data[indextr].retenciones))
                            )
                          ]),
                          _vm._v(" "),
                          _c("vs-td", [
                            _vm._v(
                              _vm._s(
                                _vm.moneyFormat(data[indextr].valor_cobrado)
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("vs-td", [
                            _vm._v(
                              _vm._s(
                                _vm.moneyFormat(
                                  _vm.calcularSaldo(data[indextr])
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("vs-td", [
                            _vm._v(_vm._s(data[indextr].des_forma_pago))
                          ]),
                          _vm._v(" "),
                          _c("vs-td", [
                            _vm._v(_vm._s(data[indextr].des_vendedor))
                          ])
                        ],
                        1
                      )
                    })
                  }
                }
              ])
            },
            [
              _c("template", { slot: "header" }, [
                _c("h5", [_vm._v("Registros:")])
              ]),
              _vm._v(" "),
              _c(
                "template",
                { slot: "thead" },
                [
                  _c("vs-th", [_vm._v("# Doc")]),
                  _vm._v(" "),
                  _c("vs-th", [_vm._v("Fecha")]),
                  _vm._v(" "),
                  _c("vs-th", [_vm._v("Vencimiento")]),
                  _vm._v(" "),
                  _c("vs-th", [_vm._v("Mora")]),
                  _vm._v(" "),
                  _c("vs-th", [_vm._v("Concepto")]),
                  _vm._v(" "),
                  _c("vs-th", [_vm._v("Valor")]),
                  _vm._v(" "),
                  _c("vs-th", [_vm._v("Retención")]),
                  _vm._v(" "),
                  _c("vs-th", [_vm._v("Cobrado")]),
                  _vm._v(" "),
                  _c("vs-th", [_vm._v("Saldo")]),
                  _vm._v(" "),
                  _c("vs-th", [_vm._v("Forma de pago")]),
                  _vm._v(" "),
                  _c("vs-th", [_vm._v("Vendedor")])
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "table-responsive" }, [
            _c("table", [
              _vm._m(1),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("td", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.moneyFormat(_vm.totalValor)) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.moneyFormat(_vm.totalRetenciones)) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.moneyFormat(_vm.totalCobrado)) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.moneyFormat(_vm.totalSaldo)) +
                        "\n              "
                    )
                  ])
                ])
              ])
            ])
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Filtros de consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Valor total")]),
        _vm._v(" "),
        _c("th", [_vm._v("Retenciones totales")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total cobrado")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total de saldo")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73a98ca6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73a98ca6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/Cartera.vue
// module id = 298
// module chunks = 0